import React from "react";
import ReactModal from "react-modal";
import ExitIcon from "../StorySwiperModal/img/exit.svg";
import "./style.scss";

export default function StoryTemplateModal({
  isOpen,
  onClose,
  onAfterClose,
  children,
  innerClass = "",
}) {
  return (
    <ReactModal
      isOpen={isOpen}
      onClose={onClose}
      onAfterClose={onAfterClose}
      overlayClassName={"story-modal-overlay"}
      className={"story-modal"}
      shouldCloseOnOverlayClick={true}
      shouldCloseOnEsc={true}
      preventScroll={true}
      appElement={document.getElementById("root")}
    >
      <button onClick={onClose} className="exit-button">
        <img src={ExitIcon} alt="close" />
      </button>
      <div className={`story-modal-content ${innerClass}`}>{children}</div>
    </ReactModal>
  );
}
